import { getAxiosInstance } from "../../../api";

export const addToRecheckList = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/recheck/item`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const addToReissueList = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/recheck/reissue`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const printReport = async (params) => {
  const api = await getAxiosInstance();

  try {
    const res = await api.get(`/qc-reports/recheck?id=${params?.id}`, {
      responseType: "blob",
    });

    return {
      success: true,
      status: res.status,
      data: res.data,
      message: "Report generated successfully",
    };
  } catch (error) {
    let message = "Something went wrong";
    let status = error?.response?.status ?? 500;
    let parsedError = null;
    if (error?.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        parsedError = JSON.parse(text);
        message = parsedError?.message ?? message;
      } catch (parseError) {
        console.error("Error parsing Blob:", parseError);
      }
    }
    console.error("Error during printReport call:", error);
    return {
      success: false,
      status,
      data: parsedError,
      message,
    };
  }
};

export const printSlip = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(`/recheck/slip?id=${params?.id}`);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getMultipleRecheckStockReceiptPrint = async (receiptIds) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/stock-receipt/multiple-recheck-reissue-slip`, {
      receipt_ids: receiptIds,
    });
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const cancelRecheck = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/recheck/cancel-recheck`, params);
    return res;
  } catch (error) {
    return error.response.data;
  }
};
export const getExportedData = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `stock-receipt/download-excel-format?receipt_id=${params?.receipt_id}`,
      {
        responseType: "blob",
      },
    );
    return response;
  } catch (error) {
    return error.response.data;
  }
};
export const getRecheckExcelDownload = async (receiptId, key) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`verification/recheck-excel-download`, {
      receipt_id: receiptId,
      key,
    });
    return response;
  } catch (error) {
    return error.response.data;
  }
};
export const uploadAdditionalExcelFiles = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(
      `/stock-receipt/recheck-excel-upload`,
      params,
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const uploadExcelFiles = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("/stock-receipt/excel-upload", params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
